export default __webpack_public_path__ + "static/media/sharyat_logo_orange.eb60f2b2.svg";